const header = {
    homepage: "https://portfolio-app-sahand2020.vercel.app/",
    title: "Portfolio",
};

const introduce = {
    name: "Sahand Torabnejad",
    job: "Front End Developer",
    description:
        "My Name is Sahand Torabnejad. I was born in October 2000. I am a Front-End developer. I have listed my skills in the toolbox below. I am a web developer and I am always learning technologies in this field. I am currently focusing on React. Practicing daily is one of my habits. I am also an elementary school teacher.",
    resume: "#",
    social: {
        github: "https://github.com/Sahand2020",
        instagram: "https://www.instagram.com/sahand.__.2020/",
    },
};

const projects = [
    {
        name: "Shop",
        id: 1,
        description:
            "This is a simple shop app (shop cart) with React.js . I used react-router-dom for routing. It's responsive.",
        technologies: ["Css", "JavaScript", "ReactJs"],
        sourceCode: "https://github.com/Sahand2020/Shop-App",
        livePreview: "https://shop-app-henna.vercel.app/",
    },
    {
        name: "Landing Page",
        id: 2,
        description:
            "This is a landing page project. I got help from Bootstrap site projects.",
        technologies: ["Html", "Css", "JavaScript", "Bootstrap"],
        sourceCode: "https://github.com/Sahand2020/Landing-Page",
        livePreview:
            "https://landing-page-d83d09o7m-sahand2020.vercel.app/Landing%20Page.html",
    },
    {
        name: "Spa App",
        id: 3,
        description:
            "This is a simple spa app. my first project with React.js. This is not responsive.",
        technologies: ["Css", "JavaScript", "ReactJs"],
        sourceCode: "https://github.com/Sahand2020/Simple-Spa-App/",
        livePreview: "https://simple-spa-app.vercel.app/",
    },
    {
        name: "Shopping Cart",
        id: 4,
        description:
            "This is a Shopping cart project by React.js. I used react-router-dom for routing, so this is a spa app too. This app is responsive.",
        technologies: ["Css", "JavaScript", "ReactJs"],
        sourceCode: "https://github.com/Sahand2020/Shopping-Cart-App",
        livePreview: "https://shopping-cart-app-three.vercel.app/products",
    },
    {
        name: "Crypto App",
        id: 5,
        description:
            "This is a responsive crypto data app. This app gets crypto data from an API and shows them. You can also search between currencies.",
        technologies: ["Css", "JavaScript", "ReactJs"],
        sourceCode: "https://github.com/Sahand2020/Crypto-App",
        livePreview: "https://crypto-app-umber-sigma.vercel.app/",
    },
    {
        name: "Login Page",
        id: 6,
        description: "This is a SPA Login/SignUp form made by React.js .",
        technologies: ["Css", "JavaScript", "ReactJs"],
        sourceCode: "https://github.com/Sahand2020/React-Login-Page",
        livePreview: "https://react-login-page-gamma.vercel.app/",
    },
];

const skills = ["Html", "Css", "JavaScript", "ReactJs", "Bootstrap", "Git"];

const contact = {
    email: "sahandtorabnejad202020@gmail.com",
};

export { header, introduce, projects, skills, contact };
